/*
 * VQ Treuepunkte-Zeile (PDP)
 *
 * Zwei Dinge: die angezeigte Punktzahl am Preis der gewaehlten Variante
 * halten, und den Erklaer-Drawer oeffnen bzw. schliessen.
 *
 * Der Drawer folgt dem Muster von info-drawer.js (Klassen active/animate,
 * trapFocus, overflow-hidden am body), damit er sich wie der
 * Versand-Drawer des Themes anfuehlt.
 */
if (!customElements.get('vq-loyalty-points')) {
  customElements.define(
    'vq-loyalty-points',
    class VqLoyaltyPoints extends HTMLElement {
      connectedCallback() {
        this.rate = parseFloat(this.dataset.rate) || 0;
        this.template = this.dataset.template || '';
        this.labelEl = this.querySelector('[data-loypts-label]');
        if (!this.labelEl || this.rate <= 0) return;

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            // Quick-Add-Modals auf derselben Seite senden dasselbe Event.
            const sectionId = event?.data?.sectionId;
            if (sectionId && this.dataset.sectionId && String(sectionId) !== this.dataset.sectionId) return;

            const variant = event?.data?.variant;
            if (!variant || typeof variant.price !== 'number') return;
            this.update(variant.price);
          });
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      update(priceInCents) {
        const points = Math.floor(priceInCents / 100) * this.rate;
        this.labelEl.textContent = this.template.replace('{points}', points);
        this.hidden = points <= 0;
      }
    }
  );
}

if (!customElements.get('vq-loyalty-drawer')) {
  customElements.define(
    'vq-loyalty-drawer',
    class VqLoyaltyDrawer extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
        this.querySelector('[data-loypts-overlay]')?.addEventListener('click', this.close.bind(this));
        this.querySelector('[data-loypts-close]')?.addEventListener('click', this.close.bind(this));
      }

      open(triggeredBy) {
        this.activeElement = triggeredBy;
        setTimeout(() => this.classList.add('animate', 'active'));

        this.addEventListener(
          'transitionend',
          () => {
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            if (typeof trapFocus === 'function') trapFocus(this, focusElement);
          },
          { once: true }
        );

        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.classList.remove('active');
        if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
      }
    }
  );

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-vq-loypts-target]');
    if (!trigger) return;

    const drawer = document.getElementById(trigger.dataset.vqLoyptsTarget);
    if (!drawer || typeof drawer.open !== 'function') return;

    event.preventDefault();
    drawer.open(trigger);
  });
}
